<div style="page-break-inside: avoid;" *ngIf="returnData?.paymentDetails?.totalAmount>0" class="mt-4"
     [ngClass]="{'container': !isSinglePageReturn, 'return-view-background-print': !isSinglePageReturn && printActive, 'return-view-background': !isSinglePageReturn && !printActive}">
  <div class="row mb-5">
    <div class="col-12 text-center" style="font-size:16px">
      <b>
        Source Tax, AIT and Regular Tax Claim
      </b>
      <br/>
      <em>[Attachment for serial no 20, 21, 22, 23 of IT-11GA(2023)]</em>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">Taxpayer Name: {{ returnData?.profileData?.assesName }}</div>
    <div class="col-sm-6 text-right">
      Assessment Year: {{ returnData?.submissionInfo?.assessmentYear }}
    </div>
  </div>
  <div class="row mt-3 mb-5">
    <div class="col-sm-6">
      TIN
      <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item}}" *ngFor="let item of returnData?.profileData?.tin.split('')"
                       class="input-default" disabled/>
            </span>
    </div>
    <div class="col-sm-6 text-right">
      Total TDS Claimed: <b>{{ returnData?.paymentDetails?.totalAmount | currencySeparatorBD }}</b>
    </div>
  </div>

  <div style="page-break-inside: avoid" class="row mb-5" *ngIf="returnData?.paymentDetails?.ibasTds?.list?.length > 0">
    <div class="col-12 text-center mb-2 font-weight-bold">
      Salary (iBAS++)
    </div>
    <div class="col-12">
      <table class="table table-bordered">
        <tbody>
        <tr class="font-weight-bold">
          <td class="text-center">Office</td>
          <td class="text-center">Designation</td>
          <td class="text-center">TDS</td>
        </tr>
        <tr *ngFor="let item of returnData?.paymentDetails?.ibasTds?.list">
          <td>{{ item.office }}</td>
          <td>{{ item.designation }}</td>
          <td class="text-right">{{ item.tdsClaim | currencySeparatorBD }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div style="page-break-inside: avoid" class="row mb-5"
       *ngIf="returnData?.paymentDetails?.salaryTds?.list?.length > 0">
    <div class="col-12 text-center mb-2 font-weight-bold">
      Salary (Others)
    </div>
    <div class="col-12">
      <table class="table table-bordered">
        <tbody>
        <tr class="font-weight-bold">
          <td class="text-center">Challan No</td>
          <td class="text-center">Challan Date</td>
          <td class="text-center">Purpose of Payment</td>
          <td class="text-center">Depositing Authority</td>
          <td class="text-center">Bank</td>
          <td class="text-center">Branch</td>
          <td class="text-center">Challan Amount</td>
          <td class="text-center">Claimed Amount</td>
        </tr>
        <tr *ngFor="let item of returnData?.paymentDetails?.salaryTds?.list">
          <td class="text-nowrap">{{ item.challanNo }}</td>
          <td class="text-center text-nowrap">{{ item.challanDate }}</td>
          <td>{{ item.section }}</td>
          <td>{{ item.depositingAuthority }}</td>
          <td>{{ item.bank }}</td>
          <td>{{ item.branchName }}</td>
          <td class="text-right">{{ item.challanAmount | currencySeparatorBD }}</td>
          <td class="text-right">{{ item.tdsClaim |currencySeparatorBD }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div style="page-break-inside: avoid" class="row mb-5"
       *ngIf="returnData?.paymentDetails?.ltuTds?.list?.length > 0">
    <div class="col-12 text-center mb-2 font-weight-bold">
      Source Tax Claim (LTU)
    </div>
    <div class="col-12">
      <table class="table table-bordered">
        <tbody>
        <tr class="font-weight-bold">
          <td class="text-center">Challan No</td>
          <td class="text-center">Description</td>
          <td class="text-center">Section</td>
          <td class="text-center">Amount</td>
        </tr>
        <tr *ngFor="let item of returnData?.paymentDetails?.ltuTds?.list">
          <td>{{ item.challanNo }}</td>
          <td>{{ item.description }}</td>
          <td>{{ item.lawSectionType }}</td>
          <td class="text-right">{{ item.amount | currencySeparatorBD }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div style="page-break-inside: avoid" class="row mb-5" *ngIf="returnData?.paymentDetails?.bankTds?.list?.length > 0">
    <div class="col-12 text-center mb-2 font-weight-bold">
      Bank TDS
    </div>
    <div class="col-12">
      <table class="table table-bordered">
        <tbody>
        <tr class="font-weight-bold">
          <td class="text-center">Name</td>
          <td class="text-center">Branch</td>
          <td class="text-center">Account No</td>
          <td class="text-center">Interest Amount</td>
          <td class="text-center">TDS</td>
        </tr>
        <tr *ngFor="let item of returnData?.paymentDetails?.bankTds?.list">
          <td>{{ item.bankName }}</td>
          <td>{{ item.bankBranch }}</td>
          <td class="text-nowrap">{{ item.accountNo }}</td>
          <td class="text-right">{{ item.interestAmount | currencySeparatorBD }}</td>
          <td class="text-right">{{ item.tdsClaim | currencySeparatorBD }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div style="page-break-inside: avoid" class="row mb-5"
       *ngIf="returnData?.paymentDetails?.savingCertificateTds?.list?.length > 0">
    <div class="col-12 text-center mb-2 font-weight-bold">
      Saving Certificate TDS
    </div>
    <div class="col-12">
      <table class="table table-bordered">
        <tbody>
        <tr class="font-weight-bold">
          <td class="text-center">Sanchayapatra Name</td>
          <td class="text-center">Registration No</td>
          <td class="text-center">Registration Date</td>
          <td class="text-center">Value</td>
          <td class="text-center">Interest</td>
          <td class="text-center">TDS</td>
        </tr>
        <tr *ngFor="let item of returnData?.paymentDetails?.savingCertificateTds?.list">
          <td>{{ item.schemeName }}</td>
          <td>{{ item.registrationNo }}</td>
          <td class="text-center text-nowrap">{{ item.purchaseDate }}</td>
          <td class="text-right">{{ item.value | currencySeparatorBD }}</td>
          <td class="text-right">{{ item.interest | currencySeparatorBD }}</td>
          <td class="text-right">{{ item.tdsClaim | currencySeparatorBD }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div style="page-break-inside: avoid" class="row mb-5" *ngIf="otherTdsInfo.length > 0">
    <div class="col-12 text-center mb-2 font-weight-bold">
      Other TDS
    </div>
    <div class="col-12">
      <table class="table table-bordered">
        <tbody>
        <tr class="font-weight-bold">
          <td class="text-center">Challan No</td>
          <td class="text-center">Challan Date</td>
          <td class="text-center">Purpose of Payment</td>
          <td class="text-center">Depositing Authority</td>
          <td class="text-center">Bank</td>
          <td class="text-center">Branch</td>
          <td class="text-center">Challan Amount</td>
          <td class="text-center">Claimed Amount</td>
        </tr>
        <tr *ngFor="let item of otherTdsInfo">
          <td class="text-nowrap">{{ item.challanNo }}</td>
          <td class="text-center text-nowrap">{{ item.challanDate }}</td>
          <td>{{ item.section }}</td>
          <td>{{ item.depositingAuthority }}</td>
          <td>{{ item.bank }}</td>
          <td>{{ item.branchName }}</td>
          <td class="text-right">{{ item.challanAmount | currencySeparatorBD }}</td>
          <td class="text-right">{{ item.tdsClaim |currencySeparatorBD }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div style="page-break-inside: avoid" class="row mb-5" *ngIf="importTdsInfo.length > 0">
    <div class="col-12 text-center mb-2 font-weight-bold">
      Other TDS
    </div>
    <div class="col-12">
      <table class="table table-bordered">
        <tbody>
        <tr class="font-weight-bold">
          <td class="text-center">Challan No</td>
          <td class="text-center">Challan Date</td>
          <td class="text-center">Purpose of Payment</td>
          <td class="text-center">Depositing Authority</td>
          <td class="text-center">Bank</td>
          <td class="text-center">Branch</td>
          <td class="text-center">Challan Amount</td>
          <td class="text-center">Claimed Amount</td>
        </tr>
        <tr *ngFor="let item of importTdsInfo">
          <td class="text-nowrap">{{ item.challanNo }}</td>
          <td class="text-center text-nowrap">{{ item.challanDate }}</td>
          <td>{{ item.section }}</td>
          <td>{{ item.depositingAuthority }}</td>
          <td>{{ item.bank }}</td>
          <td>{{ item.branchName }}</td>
          <td class="text-right">{{ item.challanAmount | currencySeparatorBD }}</td>
          <td class="text-right">{{ item.tdsClaim |currencySeparatorBD }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div style="page-break-inside: avoid" class="row mb-5" *ngIf="returnData?.paymentDetails?.commercialVehicleAit?.list?.length > 0">
    <div class="col-12 text-center mb-2 font-weight-bold">
      Commercial Vehicle TDS
    </div>
    <div class="col-12">
      <table class="table table-bordered">
        <tbody>
        <tr class="font-weight-bold">
          <td class="text-center">Challan No</td>
          <td class="text-center">Challan Date</td>
          <td class="text-center">Registration No</td>
          <td class="text-center">Transaction No</td>
          <td class="text-center">Transaction Date</td>
          <td class="text-center">Claimed Amount</td>
        </tr>
        <tr *ngFor="let item of returnData?.paymentDetails?.commercialVehicleAit?.list">
          <td class="text-nowrap">{{ item.challanNo }}</td>
          <td class="text-center text-nowrap">{{ item.challanDate }}</td>
          <td>{{ item.registrationNo }}</td>
          <td>{{ item.transactionNo }}</td>
          <td class="text-center text-nowrap">{{ item.transactionDate }}</td>
          <td class="text-right">{{ item.tdsClaimAmount | currencySeparatorBD }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div style="page-break-inside: avoid" class="row mb-5" *ngIf="returnData?.paymentDetails?.carAit?.list?.length > 0">
    <div class="col-12 text-center mb-2 font-weight-bold">
      Car AIT (Verified)
    </div>
    <div class="col-12">
      <table class="table table-bordered">
        <tbody>
        <tr class="font-weight-bold">
          <td class="text-center">Challan No</td>
          <td class="text-center">Challan Date</td>
          <td class="text-center">Registration No</td>
          <td class="text-center">Transaction No</td>
          <td class="text-center">Transaction Date</td>
          <td class="text-center">Claimed Amount</td>
        </tr>
        <tr *ngFor="let item of returnData?.paymentDetails?.carAit?.list">
          <td class="text-nowrap">{{ item.challanNo }}</td>
          <td class="text-center text-nowrap">{{ item.challanDate }}</td>
          <td>{{ item.registrationNo }}</td>
          <td>{{ item.transactionNo }}</td>
          <td class="text-center text-nowrap">{{ item.transactionDate }}</td>
          <td class="text-right">{{ item.tdsClaimAmount | currencySeparatorBD }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <hr style="border-color:#999"/>

  <div style="page-break-inside: avoid" class="row mb-5 mt-5"
       *ngIf="returnData?.paymentDetails?.regularAit?.list?.length > 0">
    <div class="col-12 text-center mb-2 font-weight-bold">
      Advance Income Tax (u/s 154)
    </div>
    <div class="col-12">
      <table class="table table-bordered">
        <tbody>
        <tr class="font-weight-bold">
          <td class="text-center">Challan No</td>
          <td class="text-center">Date</td>
          <td class="text-center">Taxes Zone</td>
          <td class="text-center">Taxes Circle</td>
          <td class="text-center">Bank</td>
          <td class="text-center">Amount</td>
          <td class="text-center">Status</td>
          <td class="text-center">View Challan</td>
        </tr>
        <tr *ngFor="let item of returnData?.paymentDetails?.regularAit?.list">
          <td class="text-nowrap">{{ item.challanNo }}</td>
          <td class="text-center text-nowrap">{{ item.challanDate }}</td>
          <td>{{ item.depositedTaxZone }}</td>
          <td>{{ item.depositedTaxCircle }}</td>
          <!--          <td>{{ item.paymentOrigin ? item.paymentOrigin : 'Others' }}</td>-->
          <td>{{ item.bank }}</td>
          <td class="text-right">{{ item.challanAmount | currencySeparatorBD }}</td>
          <td class="text-center">{{ item.verificationStatus }}</td>
          <td class="text-center"><a href="javascript:void(0)"
                                     (click)="window.open(challanBaseUrl + item.challanNo, '_blank')">View</a></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div style="page-break-inside: avoid" class="row mb-5"
       *ngIf="returnData?.paymentDetails?.taxPaidWithReturn?.list?.length > 0">
    <div class="col-12 text-center mb-2 font-weight-bold">
      Tax Paid with Return
    </div>
    <div class="col-12">
      <table class="table table-bordered">
        <tbody>
        <tr class="font-weight-bold">
          <td class="text-center">Challan No</td>
          <td class="text-center">Date</td>
          <td class="text-center">Taxes Zone</td>
          <td class="text-center">Taxes Circle</td>
          <td class="text-center">Bank</td>
          <td class="text-center">Amount</td>
          <td class="text-center">Status</td>
          <td class="text-center">View Challan</td>
        </tr>
        <tr *ngFor="let item of returnData?.paymentDetails?.taxPaidWithReturn?.list">
          <td class="text-nowrap">{{ item.challanNo }}</td>
          <td class="text-center text-nowrap">{{ item.challanDate }}</td>
          <td>{{ item.depositedTaxZone }}</td>
          <td>{{ item.depositedTaxCircle }}</td>
          <td>{{ item.bank }}</td>
          <td class="text-right">{{ item.challanAmount | currencySeparatorBD }}</td>
          <td class="text-center">{{ item.verificationStatus === 'VERIFIED' ? 'VERIFIED' : 'UNVERIFIED' }}</td>
          <td class="text-center"><a href="javascript:void(0)"
                                     (click)="window.open(challanBaseUrl + item.challanNo, '_blank')">View</a></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>


  <div style="page-break-inside: avoid" class="row mb-5"
       *ngIf="returnData?.paymentDetails?.refundClaimed?.list?.length > 0">
    <div class="col-12 text-center mb-2 font-weight-bold">
      Adjustment of Tax Refund
    </div>
    <div class="col-12">
      <table class="table table-bordered">
        <tbody>
        <tr class="font-weight-bold">
          <td class="text-center">Assessment Year</td>
          <td class="text-center">Refund Amount</td>
          <td class="text-center">Claimed Amount</td>
          <td class="text-center">Remaining Amount</td>
        </tr>
        <tr *ngFor="let item of returnData?.paymentDetails?.refundClaimed?.list">
          <td class="text-center">{{ item.assessmentYear }}</td>
          <td class="text-right">{{ item.refundAmount | currencySeparatorBD }}</td>
          <td class="text-right">{{ item.adjustedClaimAmount | currencySeparatorBD }}</td>
          <td class="text-right">{{ item.dueAmount | currencySeparatorBD }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>


  <div style="page-break-inside: avoid" class="row mb-5"
       *ngIf="returnData?.paymentDetails?.importTds?.list?.length > 0">
    <div class="col-12 text-center mb-2 font-weight-bold">
      Import TDS
    </div>
    <div class="col-12">
      <table class="table table-bordered">
        <tbody>
        <tr class="font-weight-bold">
          <td class="text-center">BIN</td>
          <td class="text-center">Office Code</td>
          <td class="text-center">Bill of Entry</td>
          <td class="text-center">Bill of Entry Date</td>
          <td class="text-center">Receipt No</td>
          <td class="text-center">Receipt Date</td>
          <th class="text-right">Invoice Value</th>
          <th class="text-right">Assessable Value</th>
          <th class="text-right">Total Tax & Duties</th>
          <th class="text-right">TDS Claimed</th>
        </tr>
        <tr *ngFor="let item of returnData?.paymentDetails?.importTds?.list">
          <td>{{ item.bin }}</td>
          <td>{{ item.officeCode }}</td>
          <td>{{ item.billOfEntry }}</td>
          <td>{{ item.billOfEntryDate | safeDate:'dd-MM-yyyy' }}</td>
          <td>{{ item.receiptNo }}</td>
          <td>{{ item.receiptDate | safeDate:'dd-MM-yyyy' }}</td>
          <td class="text-right">{{ item.invoiceAmount | currencySeparatorBD }}</td>
          <td class="text-right">{{ item.customsAmount | currencySeparatorBD }}</td>
          <td class="text-right">{{ item.totalTaxAmount | currencySeparatorBD }}</td>
          <td class="text-right">{{ item.tdsClaim | currencySeparatorBD }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div style="page-break-inside: avoid" class="row mb-5"
       *ngIf="returnData?.paymentDetails?.importAit?.list?.length > 0">
    <div class="col-12 text-center mb-2 font-weight-bold">
      AIT Import (120)
    </div>
    <div class="col-12">
      <table class="table table-bordered">
        <tbody>
        <tr class="font-weight-bold">
          <td class="text-center">BIN</td>
          <td class="text-center">Office Code</td>
          <td class="text-center">Bill of Entry</td>
          <td class="text-center">Bill of Entry Date</td>
          <td class="text-center">Receipt No</td>
          <td class="text-center">Receipt Date</td>
          <th class="text-right">Invoice Value</th>
          <th class="text-right">Assessable Value</th>
          <th class="text-right">Total Tax & Duties</th>
          <th class="text-right">TDS Claimed</th>
        </tr>
        <tr *ngFor="let item of returnData?.paymentDetails?.importAit?.list">
          <td>{{ item.bin }}</td>
          <td>{{ item.officeCode }}</td>
          <td>{{ item.billOfEntry }}</td>
          <td>{{ item.billOfEntryDate | safeDate:'dd-MM-yyyy' }}</td>
          <td>{{ item.receiptNo }}</td>
          <td>{{ item.receiptDate | safeDate:'dd-MM-yyyy' }}</td>
          <td class="text-right">{{ item.invoiceAmount | currencySeparatorBD }}</td>
          <td class="text-right">{{ item.customsAmount | currencySeparatorBD }}</td>
          <td class="text-right">{{ item.totalTaxAmount | currencySeparatorBD }}</td>
          <td class="text-right">{{ item.tdsClaim | currencySeparatorBD }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div style="page-break-inside: avoid" class="row mb-5"
       *ngIf="returnData?.paymentDetails?.environmentSurcharge?.list?.length > 0">
    <div class="col-12 text-center mb-2 font-weight-bold">
      Environmental Surcharge
    </div>
    <div class="col-12">
      <table class="table table-bordered">
        <tbody>
        <tr class="font-weight-bold">
          <td class="text-center">Motor Vehicle Registration No</td>
          <td class="text-center">Transaction ID</td>
          <td class="text-center">Bank Name</td>
          <td class="text-center">Branch Name</td>
          <td class="text-center">Payment Date</td>
          <td class="text-center">Paid Amount</td>
        </tr>
        <tr *ngFor="let item of returnData?.paymentDetails?.environmentSurcharge?.list">
          <td>{{ item.vehicleRegNo }}</td>
          <td class="text-nowrap">{{ item.transactionId }}</td>
          <td>{{ item.bank }}</td>
          <td>{{ item.branch }}</td>
          <td>{{ item.paymentDate }}</td>
          <td class="text-right">{{ item.paidAmount | currencySeparatorBD }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>


<div style="page-break-inside: avoid;" *ngIf="section163ForwardData && section163ForwardData > 0" class="mt-4"
     [ngClass]="{'container': !isSinglePageReturn, 'return-view-background-print': !isSinglePageReturn && printActive, 'return-view-background': !isSinglePageReturn && !printActive}">
  <div class="row mb-5">
    <div class="col-12 text-center" style="font-size:16px">
      <em>[Attachment for section 163 
        <span *ngIf="returnData?.submissionInfo?.assessmentYear === currentAY">(6)]</span>
        <span *ngIf="returnData?.submissionInfo?.assessmentYear !== currentAY">(8)]</span>
      </em>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">Taxpayer Name: {{ returnData?.profileData?.assesName }}</div>
    <div class="col-sm-6 text-right">
      Assessment Year: {{ returnData?.submissionInfo?.assessmentYear }}
    </div>
  </div>
  <div class="row mt-3 mb-5">
    <div class="col-sm-6">
      TIN
      <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item}}" *ngFor="let item of returnData?.profileData?.tin.split('')"
                       class="input-default" disabled/>
            </span>
    </div>
  </div>

  <div style="page-break-inside: avoid" class="row mb-5">
    <div class="col-12">
      <table class="table table-bordered">
        <tbody>
        <tr>
          <td>Amount of tax carried forward U/S 163
            <span *ngIf="returnData?.submissionInfo?.assessmentYear === currentAY">(6)</span>
            <span *ngIf="returnData?.submissionInfo?.assessmentYear !== currentAY">(8)</span>
          </td>
          <td class="text-right">{{ section163ForwardData | currencySeparatorBD }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
